import React, { Component } from "react";
import { Divider, Row, Layout, Button } from "antd";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import BestCatsTable from "../../table/BestCatsTable";
import TierListTable from "../../table/TierListTable";
import {
  FacebookShareButton,
  RedditShareButton,
  TwitterShareButton,
  VKShareButton,
  FacebookIcon,
  RedditIcon,
  TwitterIcon,
  VKIcon,
} from "react-share";
import VenatusAd from "../../ads/VenatusAd";
import VenatusAdWithPlaceholder from "../../ads/VenatusAdWithPlaceholder";
import {
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_MOBILE_INCONTENT,
  VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL,
  VENATUS_RICH_MEDIA,
} from "../../utilities/constants";

const shareURL = "https://mygamatoto.com/dynamites-tier-list";
const { Content } = Layout;

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

class Dynamites extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
      compareCatsLevels: 30,
    };
  }
  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    document.title = "Dynamites Tier List | Battle Cats Wiki for Cat Stats";
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 636) {
      adjustViewport = 22;
    } else if (window.innerWidth < 948) {
      adjustViewport = 34;
    } else {
      adjustViewport = 46;
    }

    this.setState({
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  showModal = () => {
    this.setState({ isModalVisible: true });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  render() {
    const bestCats = [
      {
        key: "045-1",
        name: "Lesser Demon Cat",
        number: "045-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 5500,
        damage: 4125,
        range: 180,
        kb: 3,
        speed: 12,
        dps: 1820,
        target: "Single",
        tba: "2.27",
        anim: "0.93",
        spawn: "28.20",
        cost: 3000,
        ability: "u1Not affected byu2: b1Weakenb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "456-1",
        name: "Wonder MOMOCO",
        number: "456-1",
        form: "Normal",
        rarity: "Legendary Rare",
        level: 1,
        health: 10000,
        damage: 9000,
        range: 375,
        kb: 2,
        speed: 13,
        dps: 1343,
        target: "Area",
        tba: "6.70",
        anim: "0.93",
        spawn: "124.53",
        cost: 4500,
        ability:
          "u1Against red, black, angelu2: b1Freezeb2 (100% chance to freeze for 2.0s) \nu1General Abilitiesu2: b1Wave attackb2 (100% chance to perform a Lv.8 Shockwave attack (Range: 1732))\nu1Not affected byu2: b1Waveb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "060-1",
        name: "Baby Cat",
        number: "060-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 10000,
        damage: 5500,
        range: 140,
        kb: 2,
        speed: 9,
        dps: 552,
        target: "Area",
        tba: "9.97",
        anim: "2.00",
        spawn: "51.20",
        cost: 3150,
        ability:
          "u1Against floating, alienu2: b1Knockbackb2 (30% chance of knockback)\nu1Not affected byu2: b1Freezeb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "144-1",
        name: "Nurse Cat",
        number: "144-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 2625,
        damage: 2638,
        range: 435,
        kb: 3,
        speed: 6,
        dps: 400,
        target: "Area",
        tba: "6.60",
        anim: "3.30",
        spawn: "121.20",
        cost: 4350,
        ability:
          "u1Against black, floatingu2: b1Slowb2 (50% chance to slow for 4.0s) b1Knockbackb2 (50% chance of knockback)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "043-1",
        name: "Ice Cat",
        number: "043-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3500,
        damage: 2250,
        range: 325,
        kb: 3,
        speed: 8,
        dps: 370,
        target: "Area",
        tba: "6.10",
        anim: "1.80",
        spawn: "57.87",
        cost: 3300,
        ability: "u1Against redu2: b1Freezeb2 (50% chance to freeze for 4.0s)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "044-1",
        name: "Cat Machine",
        number: "044-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 12000,
        damage: 8750,
        range: 140,
        kb: 1,
        speed: 9,
        dps: 715,
        target: "Area",
        tba: "12.23",
        anim: "5.60",
        spawn: "64.53",
        cost: 3600,
        ability:
          "u1Against red, alienu2: b1Resistantb2 (only takes 0.25x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "618-1",
        name: "Summoner Satoru",
        number: "618-1",
        form: "Normal",
        rarity: "Uber Rare",
        level: 1,
        health: 4625,
        damage: 3150,
        range: 470,
        kb: 3,
        speed: 20,
        dps: 362,
        target: "Area",
        tba: "8.70",
        anim: "3.67",
        spawn: "84.87",
        cost: 3600,
        ability:
          "u1Against akuu2: b1Slowb2 (100% chance to slow for 4.0s) \r\nu1General Abilitiesu2: b1Long Distanceb2 (Effective range 370~770) b1Shield Piercingb2 (20% chance to break Aku shields)\r\nu1Not affected byu2: b1Surgeb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "520-1",
        name: "Lasvoss",
        number: "520-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 5000,
        damage: 15000,
        range: 320,
        kb: 2,
        speed: 8,
        dps: 900,
        target: "Area",
        tba: "16.67",
        anim: "2.57",
        spawn: "71.20",
        cost: 5400,
        ability:
          "u1General Abilitiesu2: b1Strengthenb2 (attack power increases by 50% at 1% health) b1Surviveb2 (100% chance to survive a lethal strike) b1Savage Blowb2 (30% chance to inflict an attack with 2x damage to non-Metal enemies)\nu1Not affected byu2: b1Weakenb2, b1Freezeb2, b1Slowb2, b1Knockbackb2, b1Curseb2, b1Warpb2, b1Waveb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "428-1",
        name: "Cat Clan Heroes",
        number: "428-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3500,
        damage: 2500,
        range: 350,
        kb: 3,
        speed: 15,
        dps: 278,
        target: "Area",
        tba: "9.03",
        anim: "2.10",
        spawn: "71.20",
        cost: 3450,
        ability:
          "u1Against red, black, floatingu2: b1Weakenb2 (100% chance to weaken by 50% for 4.0s) \r\nu1General Abilitiesu2: b1Criticalb2 (3% chance of a critical hit) b1Long Distanceb2 (Effective range 200~500)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "058-1",
        name: "Marauder Cat",
        number: "058-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3250,
        damage: 500,
        range: 195,
        kb: 3,
        speed: 7,
        dps: 100,
        target: "Single",
        tba: "5.00",
        anim: "1.03",
        spawn: "47.87",
        cost: 2250,
        ability:
          "u1General Abilitiesu2: b1Criticalb2 (20% chance of a critical hit)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
    ];

    const tierList = [
      {
        tier: "SS",
        cats: [],
      },
      {
        tier: "S",
        cats: [],
      },
      {
        tier: "A+",
        cats: [{ name: "Lesser Demon Cat", number: "045-1" }],
      },
      {
        tier: "A",
        cats: [{ name: "Wonder MOMOCO", number: "456-1" }],
      },
      {
        tier: "B+",
        cats: [{ name: "Baby Cat", number: "060-1" }],
      },
      {
        tier: "B",
        cats: [
          { name: "Nurse Cat", number: "144-1" },
          { name: "Ice Cat", number: "043-1" },
        ],
      },
      {
        tier: "B-",
        cats: [],
      },
      {
        tier: "C+",
        cats: [
          { name: "Cat Machine", number: "044-1" },
          { name: "Summoner Satoru", number: "618-1" },
        ],
      },
      {
        tier: "C",
        cats: [
          { name: "Lasvoss", number: "520-1" },
          { name: "Cat Clan Heroes", number: "428-1" },
          { name: "Marauder Cat", number: "058-1" },
        ],
      },
      {
        tier: "D",
        cats: [],
      },
    ];

    return (
      <div>
        <div className="pagetitle">
          <h1 style={{ padding: "10px 0 0 0", marginBottom: "6px" }}>
            Tier List
          </h1>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content className="flexible-width">
            <Row style={{ padding: "16px 0 0 0" }}>
              <div>
                {this.state.viewportWidth > 1024 ? (
                  <span>
                    <VenatusAdWithPlaceholder
                      placementId={VENATUS_DESKTOP_LEADERBOARD}
                    />
                  </span>
                ) : (
                  ""
                  // <VenatusAdWithPlaceholder
                  //   placementId={VENATUS_MOBILE_INCONTENT}
                  // />
                )}
                <h2 style={{ marginTop: "12px", fontSize: "24px" }}>
                  The Dynamites Tier List
                </h2>
                <p></p>
                <div>
                  Tier list for The Dynamites, listed from worst to best. Credit
                  goes to the Tier List on the{" "}
                  <a href="https://www.reddit.com/r/battlecats/wiki/index">
                    Reddit r/battlecats Wiki
                  </a>
                  &nbsp;under the Cat Guides.
                  <p></p>
                  <i>Last updated: 10 October 2021</i>
                </div>
              </div>
            </Row>

            <Row style={{ margin: "16px 0 0 0" }}>
              <FacebookShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <TwitterShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - The Dynamites Tier List"
                style={{ marginRight: "0.25rem" }}
              >
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <RedditShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <RedditIcon size={32} round />
              </RedditShareButton>
              <VKShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - The Dynamites Tier List"
                style={{ marginRight: "0.25rem" }}
              >
                <VKIcon size={32} round />
              </VKShareButton>
            </Row>
            {this.state.viewportWidth > 1024 ? (
              ""
            ) : (
              <div style={{ margin: "10px 0 0 0" }}>
                <div
                  class="vm-placement"
                  id="vm-av"
                  data-format="isvideo"
                ></div>
              </div>
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  10.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[9].number +
                      ".png"
                    }
                    alt={bestCats[9].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[9].number.slice(0, 3) +
                          "/" +
                          bestCats[9].name
                        }
                      >
                        {bestCats[9].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Its cursed sword reduces the offensive power but might deliver
                  critical hits. Known as the "Metal Killer".
                  <p></p>
                  <b>Other forms: </b>Berserker Cat, Paladin Cat
                  <p></p>
                  <b>Pros: </b>Useful purely for his critical ability, but don't
                  estimate him just because of this — in true form, he has a 50%
                  chance of making a critical attack. As one of the cheapest
                  ubers, he does extremely well in Metal stages.
                  <p></p>
                  <b>Cons: </b>Don't bother using him in non-metal stages. Even
                  maxing out his talents won't compensate enough for his
                  weaknesses.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Marauder Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              style={{ marginTop: "8px" }}
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            /> */}
            {/* <div id="waldo-tag-14680"></div> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  9.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[8].number +
                      ".png"
                    }
                    alt={bestCats[8].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[8].number.slice(0, 3) +
                          "/" +
                          bestCats[8].name
                        }
                      >
                        {bestCats[8].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A brave band of Cats out to defeat the
                  King of Evil. Long-range Area strikes have chance of Critical.
                  100% chance to weaken Red, Black, and Floating.
                  <p></p>
                  <b>Other forms: </b>Cat Guild Heroes, Cat Quest Heroes
                  <p></p>
                  <b>Pros: </b>Very useful against Relic enemies in its true
                  form, when it also gains Curse immunity, higher health and a
                  longer duration for its weaken ability.
                  <p></p>
                  <b>Cons: </b>Not so useful against other enemy types like Red,
                  Black and Floating, for which there are usually better
                  replacements.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Cat Clan Heroes"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  8.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[7].number +
                      ".png"
                    }
                    alt={bestCats[7].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[7].number.slice(0, 3) +
                          "/" +
                          bestCats[7].name
                        }
                      >
                        {bestCats[7].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Incarnation of Evil summoned to eradicate the forces of Good.
                  May strike a Savage Blow imbued with dark power. Survives
                  once, stronger after taking damage.
                  <p></p>
                  <b>Other forms: </b>Ultimate Lasvoss, Lasvoss Reborn
                  <p></p>
                  <b>Pros: </b>Base stats are off the charts. Immune to
                  basically everything. Also on the{" "}
                  <Link to={"/best-cats-for-attack"}>Best Cats for Attack</Link>{" "}
                  list.
                  <p></p>
                  <b>Cons: </b>Seriously troublesome to use. His long time
                  between attacks causes him to either miss the enemy or get
                  knocked back by pushers. To make good use of him, your entire
                  lineup needs to be selected with him in mind. Try him out and
                  you'll understand...even with his high base stats, not sure if
                  he's worth it.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Lasvoss"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  7.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[6].number +
                      ".png"
                    }
                    alt={bestCats[6].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[6].number.slice(0, 3) +
                          "/" +
                          bestCats[6].name
                        }
                      >
                        {bestCats[6].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  To save the world, this boy made a pact with the Aku. Commands
                  dark minions for a good cause... for now. Long-range Area
                  attacks 100% Slow vs Aku
                  <p></p>
                  <b>Other forms: </b>Dark Summoner Satoru
                  <p></p>
                  <b>Pros: </b>Great crowd controller for Aku enemies, with 100%
                  chance of Slow. Immunity to Surge and decent respawn rate also
                  makes him stackable against them.
                  <p></p>
                  <b>Cons: </b>Poor health and damage stats make it truly useful
                  only against Aku enemies. Despite his low Shield Break chance
                  of 20%...there aren't many anti-Aku cats out there, and
                  beggars can't be choosers.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Summoner Satoru"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              style={{ marginTop: "8px" }}
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            <Row style={{ padding: "16px 0 0 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  6.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[5].number +
                      ".png"
                    }
                    alt={bestCats[5].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[5].number.slice(0, 3) +
                          "/" +
                          bestCats[5].name
                        }
                      >
                        {bestCats[5].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>Series 1 Weaponized Machine System (MS)
                  developed by the government (Area Attack) Resitant to Red
                  &amp; Alien attacks.
                  <p></p>
                  <b>Other forms: </b>Cat Machine Mk 2, Cat Machine Mk 3<p></p>
                  <b>Pros: </b>Most useful in its true form, when it gains the
                  Wave Shield ability. Enormous health and damage, especially
                  against Red and Alien enemies, serving well as a tanker
                  against them. Does well in stages with enemies like{" "}
                  <Link to={"/enemyinfo/206/Berserkory"}>Berserkory</Link>,{" "}
                  <Link to={"/enemyinfo/044/Dober%20P.D"}>Dober P.D</Link> etc.
                  In fact, it's so strong that the Cat Machine Mk 3 is also on
                  the{" "}
                  <Link to={"/best-cats-for-attack"}>Best Cats for Attack</Link>{" "}
                  list.
                  <p></p>
                  <b>Cons: </b>Tends to miss because of his long attack. His
                  Wave Shield ability is typically replaceable by{" "}
                  <Link to={"/catinfo/034/Octopus%20Cat"}>Octopus Cat</Link>.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Cat Machine"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  5.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[4].number +
                      ".png"
                    }
                    alt={bestCats[4].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[4].number.slice(0, 3) +
                          "/" +
                          bestCats[4].name
                        }
                      >
                        {bestCats[4].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A Cat that was entranced by a girl hailing
                  from the Land of Ice. It is frozen. Might freeze Red enemies.
                  (Area Attack)
                  <p></p>
                  <b>Other forms: </b>Ice Queen Cat, Ice Crystal Cat
                  <p></p>
                  <b>Pros: </b>Great anti-red crowd controller from a relatively
                  safe distance, but only in true form. Decent respawn rate
                  allows her to be stacked to permanently freeze Red enemy
                  stages.
                  <p></p>
                  <b>Cons: </b>Against red enemies,{" "}
                  <Link to={"/catinfo/040/iCat"}>iCat</Link> often does the
                  trick. In her normal and evolved form, the lower chance of
                  freezing (50%) makes her far less useful. Also has a tendency
                  to miss due to having a long foreswing.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Ice Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  4.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[3].number +
                      ".png"
                    }
                    alt={bestCats[3].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[3].number.slice(0, 3) +
                          "/" +
                          bestCats[3].name
                        }
                      >
                        {bestCats[3].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Her warm smile and healing aura take away the sting of her
                  piercing syringe (Area attack) Might knockback/slow
                  Black/Floating enemies.
                  <p></p>
                  <b>Other forms: </b>Heartful Nurse Cat, Joyful Nurse Cat
                  <p></p>
                  <b>Pros: </b>Decent crowd controller against Black and
                  Floating enemies, managing to outrange{" "}
                  <Link to={"/catinfo/026/Bahamut%20Cat"}>Bahamut Cat</Link> in
                  true form, with higher DPS and respawn rate.
                  <p></p>
                  <b>Cons: </b>Knockback ability is less useful against Black
                  enemies, which tend to have high knockback count. Tends to
                  miss due to having a long foreswing. Not the best cat for late
                  game stages.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Nurse Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  3.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[2].number +
                      ".png"
                    }
                    alt={bestCats[2].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[2].number.slice(0, 3) +
                          "/" +
                          bestCats[2].name
                        }
                      >
                        {bestCats[2].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A baby Cat that still can't do anything by
                  itself. Luckily, daddy is there to help. Might knockback
                  Floating &amp; Aliens (Area Atk)
                  <p></p>
                  <b>Other forms: </b>Baby Cats, Cats in the Cradle
                  <p></p>
                  <b>Pros: </b>Gains extra range and a Shockwave ability in True
                  form, making him a great situational uber for Floating and
                  Alien enemies. Use him when you need extra firepower against
                  them. Increased speed, health and respawn rate sometimes allow
                  you to squeeze in one last respawn against enemy pushers, thus
                  saving the day.
                  <p></p>
                  <b>Cons: </b>Barely passable as a tanker in its normal and
                  evolved form. Best to upgrade his levels only when going for
                  his True form.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Baby Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  2.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[1].number +
                      ".png"
                    }
                    alt={bestCats[1].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[1].number.slice(0, 3) +
                          "/" +
                          bestCats[1].name
                        }
                      >
                        {bestCats[1].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>The galaxy's most stylish detective,
                  cleaning up cosmic crime with her cutting edge Cutie Beam.
                  Area Wave attacks freeze Red/Black/Angels.
                  <p></p>
                  <b>Other forms: </b>Cutie MOMOCO
                  <p></p>
                  <b>Pros: </b>This Legendary is essentially an overpowered{" "}
                  <Link to={"/catinfo/440/Empress%20Chronos"}>
                    Empress Chronos
                  </Link>
                  , but only against red, black and angels. Great crowd
                  controller with multi-hit attack: first hit freezes with a
                  massive shockwave that spans a good portion of the map, second
                  hit is nothing to shout about, third hit deals a great amount
                  of damage. Her immunity to wave attacks also make her a great
                  choice for stages with waves.
                  <p></p>
                  <b>Cons: </b>You won't be choosing her for her damage, as her
                  multi-hit means she has a tendency to miss on her last attack.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Wonder MOMOCO"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            <Row style={{ padding: "0px 0 0px 0" }}>
              <Row style={{ padding: "0px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  1.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[0].number +
                      ".png"
                    }
                    alt={bestCats[0].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[0].number.slice(0, 3) +
                          "/" +
                          bestCats[0].name
                        }
                      >
                        {bestCats[0].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A mad cat that sacrificed itself to a a
                  demon from the netherworld. Attacks with extreme force.
                  <p></p>
                  <b>Other forms: </b>Greater Demon Cat, Balrog Cat
                  <p></p>
                  <b>Pros: </b>The go-to cat for most stages. Pair him in the
                  Unit Attack Up (Sm), Lust for Battle, combo to get an easy
                  boost. Upgrade his level and unlock his talents the moment you
                  can — this is a decision you won't regret. He has the second
                  highest DPS in the game after{" "}
                  <Link to={"/catinfo/026/Awakened%20Bahamut%20Cat"}>
                    Awakened Bahamut Cat
                  </Link>
                  , which coupled with his quick cooldown and enormous health
                  makes him one of the best damage dealers and tankers in the
                  game.
                  <p></p>
                  <b>Cons: </b>His one major drawback is his single target
                  attack, but honestly if he had area attack as well, he'd be at
                  least a Legendary uber or better. Seriously, just get him.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Lesser Demon Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            <Row style={{ padding: "6px 0 6px 0", marginTop: "6px" }}>
              <Divider orientation="left" style={{ fontSize: "24px" }}>
                Tier List
              </Divider>
              <TierListTable
                selectedCats={tierList}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "6px 0 6px 0" }}>
              <Divider />
              <h3>Compare all 10 cats below</h3>
              <BestCatsTable
                selectedCats={bestCats}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row
              style={{
                padding: "24px 20px 18px 20px",
                backgroundColor: "#ffa50038",
                textAlign: "center",
                margin: "0 0 8px 0",
              }}
            >
              <div style={{ fontSize: "16px" }}>
                Want to compare the stats of any cat in The Battle Cats?
              </div>
              <Divider
                style={{ backgroundColor: "orange", marginTop: "12px" }}
              ></Divider>
              <Button href="/comparecats" size="large">
                Compare more cats
              </Button>
            </Row>
          </Content>
        </Layout>
        {this.state.viewportWidth > 1024 ? (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL}
              style={{ display: "none" }}
            />
          </div>
        ) : (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA}
              style={{ display: "none" }}
            />
          </div>
        )}
        {/* <HorizontalAdPopup
          dataAdClient="ca-pub-1920730948516638"
          dataAdSlot="3694383950"
        ></HorizontalAdPopup> */}
        {/* <div id="waldo-tag-14678"></div> */}
      </div>
    );
  }
}

export default Dynamites;

Dynamites.propTypes = {
  applyViewportChange: PropTypes.number,
};

Dynamites.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components/content/tierlist/Dynamites.js